var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"type":"area","height":"200","options":_vm.options.chartOptions,"series":_vm.options.series}})}
var staticRenderFns = []

export { render, staticRenderFns }